import { breakPoint } from '@scp/ui-shared/theme/variables';
export var mediaQueryMobileMax = "(max-width: ".concat(breakPoint.mobile, "px)");
export var mediaQueryTabletMax = "(max-width: ".concat(breakPoint.tablet, "px)");